import PricingTable from "../PricingTable/PricingTable";
import { CardType } from "../PricingTable/PricingTable";
import "./accountPlans.css";

import FREEPLAN from "../Assets/freeplan-img.png";
import PREMIUMPLAN from "../Assets/premiumplan-img.png";
import BUSINESSPLAN from "../Assets/businessplan-img.png";

const AccountsPlans = () => {
  let cards: CardType[] = [
    {
      cardHeading: "Free",
      cardMonthlyPricing: 0,
      cardAnnualPricing: 0,
      cardPoints: [
        "10 QR Codes",
        "10,000 Monthly Scans ",
        "Basic Customization",
        "Email support",
      ],
      cardCta: "Signup",
      cardId: "",
      cardRecommmended: false,
      cardImg: FREEPLAN,
    },
    {
      cardHeading: "Premium",
      cardMonthlyPricing: 10.99,
      cardAnnualPricing: 144.99,
      cardPoints: [
        "10 Dynamic QR Codes",
        "100,000 Monthly Scans",
        "Tracking with Analytics",
        "Premium QR Code Customization",
        "Priority Customer Support",
      ],
      cardCta: "Purchase",
      cardId: process.env.REACT_APP_STRIPE_PRODUCT_1,
      cardRecommmended: true,
      cardImg: PREMIUMPLAN,
    },
    {
      cardHeading: "Business",
      cardMonthlyPricing: 49.99,
      cardAnnualPricing: 669.99,
      cardPoints: [
        "Unlimited Monthly Scans",
        "Unlimited Dynamic QR Codes",
        "Detailed Tracking with Analytics",
        "Premium QR Code Customization",
        "Top Priority Customer Support",
      ],
      cardCta: "Purchase",
      cardId: process.env.REACT_APP_STRIPE_PRODUCT_2,
      cardRecommmended: false,
      cardImg: BUSINESSPLAN,
    },
  ];

  return (
    <div className="accountPlans">
      <PricingTable
        heading="Pricing"
        paragraph="QR Sharp offers unparalleled customization, security, and efficiency at prices that fit any budget. See how QR Sharp can transform your digital interactions below."
        annualSaving={20}
        heading2="Enterprise"
        paragraph2="Need something for tailor-made for your organization? Don't hesitate to get in contact. We can offer white labeling, higher usage limits and API integration."
        cta="Contact Us"
        cards={cards}
      />
    </div>
  );
};

export default AccountsPlans;
